import React, { useRef } from 'react';

const DateInput = ({ 
  type = "date", 
  className = "form-control", 
  value, 
  onChange, 
  name, 
  placeholder,
  required,
  disabled,
  ...props 
}) => {
  const inputRef = useRef(null);
  const isTypable = type === 'time';

  const handleClick = () => {
    if (inputRef.current && !disabled && !isTypable) {
      // Focus the input and trigger the date picker
      inputRef.current.focus();
      inputRef.current.showPicker?.();
    }
  };

  const handleKeyDown = (e) => {
    if (isTypable) return;
    // Allow normal input behavior for keyboard users
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <input
      ref={inputRef}
      type={type}
      className={className}
      value={value}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      onClick={isTypable ? undefined : handleClick}
      onKeyDown={isTypable ? undefined : handleKeyDown}
      style={{ 
        cursor: disabled ? 'not-allowed' : isTypable ? 'text' : 'pointer',
        userSelect: isTypable ? 'auto' : 'none',
        ...props.style 
      }}
      {...props}
    />
  );
};

export default DateInput;
